import styled from 'styled-components'

const RawHtmlUi = styled.div.attrs(p => ({
  id: p.attrId,
}))`
  min-height: 20px;
  ${({ styles = {} }) => styles}
`
export default RawHtmlUi
